import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';

export const Route = createFileRoute('/_app/leads_/details/$leadId/history/')({
    beforeLoad: ({ location }) => authoriseUser(Object.values(ROLES), location),
    component: () => (
        <Navigate
            from="/leads/details/$leadId/history/"
            to="/leads/details/$leadId/history/$categoryId"
            params={(params) => ({ ...params, categoryId: 'all' })}
            search
        />
    ),
});
